import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import {
  NODE_PARAGRAPH,
  render,
  MARK_LINK,
} from 'storyblok-rich-text-react-renderer';
import FancyTitle from '../fancy-title';
import LinkResolver from '../../helpers/link-resolver';
import StoryBlokLink from './StoryBlokLink';

const QUICK_INSIGHT_BG = 'linear-gradient(135deg, #001c0a 0%, #006837 100%)';

export default function BlogpostQuickInsight(blok) {
  const textColor = blok.text_color || 'text-white';
  const borderColor = blok.border_color || 'border-latori-green-dark-dark';
 console.log({ blok })
  return (
    <div
      {...storyblokEditable(blok)}
      className={`quick-insight px-5 pt-5 pb-10 border-2 border-solid rounded border-[${borderColor}] border my-5`}
      style={{ borderColor }}
    >
      <div
        className="flex items-center w-full dark text-white  px-4"
        style={{ backgroundImage: QUICK_INSIGHT_BG }}
      >
        <FancyTitle
          text={blok.question}
          marginBottom=""
          fontSize="text-2xl"
          className={`fancy-title-small w-[calc(100%+16px)] p-[10px] hyphens-auto
            ${textColor} mx-[-10px] -mt-5`}
          tag={blok.heading || 'h3'}
        />
      </div>
      <div className="pt-6 card-section-content">
        {render(blok.answer, {
          markResolvers: {
            [MARK_LINK]: LinkResolver,
          },
          nodeResolvers: {
            // eslint-disable-next-line react/no-unstable-nested-components
            [NODE_PARAGRAPH]: (children) => (
              <p className="first-of-type:mt-0 last-of-type:mb-0">
                {children}
              </p>
            ),
          },
        })}
      </div>
      {blok.link && blok.link_text && (
        <div className="pt-6">
          <StoryBlokLink link={blok.link} className="text-latori-pink font-semibold text-sm hover:underline">
            {blok.link_text}
          </StoryBlokLink>
        </div>
      )}
    </div>
  );
}